import iconUnauthorized from "../../assets/images/un_authorized_icon_1.png";

const PageNotFound = () => {
  return (
    <div className="container h-100">
      <div className="row h-100 justify-content-center align-items-center">
        <div className="col-12">
          <img
            src={iconUnauthorized}
            width="150px"
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            alt="unauthorized"
          />
          <hr style={{ width: "50%" }} />
          <h5 className="text-center">Sorry, you don't have access.</h5>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
